
import React, { useEffect, useState } from "react";
import axios from 'axios';
import ElementForm from "./ElementForm";
import { Navigate } from "react-router-dom";

const myEnv = process.env
const protocole = myEnv.REACT_APP_SERVERPROTOCOLE
const host = myEnv.REACT_APP_SERVERHOSTNAME
const port = myEnv.REACT_APP_SERVERPORT
const apiIGLS = `${protocole}${host}:${port}`

const ElementAdd = (params) => {

  const {typeElement} = params
  const [fini, setFini] = useState(false)
  const [url, setUrl] = useState(`/${typeElement}/add`)

  let objetCourant = {}

  useEffect(() => {
  }, [url])

  // onSubmit handler
  const onSubmit = (element) => {
    console.log(" ! Ajout - form commun edit et add")
    delete element.id

    const token = localStorage.getItem('token-access') ? localStorage.getItem('token-access') : ""
    const headers = {
        'accept': 'application/json',
        'x-access-token': token,
    }

    // ! indispensable pour les fichiers

    if (typeElement === 'donnee' ) {
        headers['content-type']= 'multipart/form-data'
        if (element.contexte.length){
            element.contexte = element.contexte.join("-")
        }
    }

    //traitement du fichier - je rcupere le fichier
    ///je le stocke et je créer une url pour l'appel que je stocke

    console.log("je vais ajouter l'element de type " + typeElement)
    console.log(element)

    axios({
      method: 'post',
      url:  `${apiIGLS}/${typeElement}`,
      headers: headers,
      data: element
    })
    .then(res => {
      //console.log("Ma reponse")
      //console.log(res.status)
      if (res.status === 200 || res.status === 201){
        setFini(true)
        setUrl(`/${typeElement}/${res.data.id}`)
        alert('Element de type ' + typeElement +  ' id ' + res.data.id + ' créé ')
      }
      else {
        Promise.reject()
      }
    })
    .catch((erreur) => {
      console.log(erreur)
      if (erreur.response.status === 401){
        alert("Une erreur d'authentification a eu lieu lors de la création"
          + " de l'element de type "
          + typeElement
          + " Erreur : "
          + erreur.response.data)
      } if (erreur.response.status === 403){
        alert("Une erreur d'autorisation a eu lieu lors de la création"
          + " de l'element de type "
          + typeElement
          + " Erreur : "
          + erreur.response.data)
      } else {
        alert("Une erreur a eu lieu lors de la création"
          + " de l'element de type "
          + typeElement
          + " Erreur : "
          + erreur.message)
      }
    })
  }

  // renvoie le formulaire
  return (
    <>
    {!fini && <ElementForm
      typeAction="Ajouter"
      initialValues={objetCourant}
      typeElement={typeElement}
      onSubmit={onSubmit}
    />}
    {fini && <Navigate to={url} replace={true}/>}
    </>
  )
}

export default ElementAdd